namespace Solovis.Reports.TableFilters {


    export class NumericFilterControl extends Solovis.UI.BaseControl {
        private _initialState: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByNumberMatch;
        private _onStateChangedHandler: () => void;
        private _percentageMode: boolean;

        private _minNumberBox: DevExpress.ui.dxNumberBox;
        private _maxNumberBox: DevExpress.ui.dxNumberBox;     
        private _notSetCheckBox: DevExpress.ui.dxCheckBox;           

        constructor(options) {
            super(options);

            this._initialState = options.initialState;
            this._onStateChangedHandler = options.onStateChanged;
            this._percentageMode = options.percentageMode;
        }

        public doInit() {
        }

        public doRender() {
            let self = this;

            let min = this._initialState ? this._initialState.min : null;
            let max = this._initialState ? this._initialState.max : null;

            if (this._percentageMode) {
                min = Solovis.isNotNull(min) ? (min * 100) : null;
                max = Solovis.isNotNull(max) ? (max * 100) : null;
            }

            let minDiv = $("<div>").css("width", "140px").css("display", "inline-block").appendTo(this.container);
            $(minDiv).dxNumberBox({
                value: this._initialState ? this._initialState.min : null,
                onValueChanged: function () {
                    if (self._onStateChangedHandler) {
                        self._onStateChangedHandler();
                    }
                }
            });
            this._minNumberBox = $(minDiv).dxNumberBox("instance");

            $("<span>").text(" to ")
                .css("display", "inline-block")
                .css("padding-top", "8px")
                .css("text-align", "center")
                .css("vertical-align", "top")
                .css("width", "40px")
                .appendTo(this.container);

            let maxDiv = $("<div>").css("width", "140px").css("display", "inline-block").appendTo(this.container);
            $(maxDiv).dxNumberBox({
                value: this._initialState ? this._initialState.max : null,
                onValueChanged: function () {
                    if (self._onStateChangedHandler) {
                        self._onStateChangedHandler();
                    }
                }
            });
            this._maxNumberBox = $(maxDiv).dxNumberBox("instance");

            let notSetRow = $("<div>").appendTo(this.container);
            let notSetDiv = $("<div>").appendTo(notSetRow).css("padding-top", "5px");
            $(notSetDiv).dxCheckBox({
                text: "Not Set",
                value: !!(!this._initialState || this._initialState.notSet),
                onValueChanged: function () {
                    if (self._onStateChangedHandler) {
                        self._onStateChangedHandler();
                    }
                }
            });
            this._notSetCheckBox = $(notSetDiv).dxCheckBox("instance");
        }

        public getCurrentState(): Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByNumberMatch {
            if (this._notSetCheckBox) {
                let min = this._minNumberBox.option("value");
                let max = this._maxNumberBox.option("value");

                let newState: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByNumberMatch = {
                    min: min,               
                    max: max,
                    notSet: this._notSetCheckBox.option("value")
                };

                return newState;
            }
            else {
                return this._initialState;
            }
        }

    }

}